import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { getUserData } from '../../util/manageUserData';

@Component({
  selector: 'app-store-selection',
  templateUrl: './store-selection.component.html',
  styleUrls: ['./store-selection.component.css'],
})
export class StoreSelectionComponent implements OnInit {
  constructor(private router: Router) {}

  selectValue = 'All';
  locations = [];
  allLocations = {};
  locationCount = 0;
  selectedObjectAll = { id: '*', text: 'All' };
  selectAll = false;
  image_key = environment.client_env;
  //@ts-ignore
  imageUrl = environment[this.image_key]['sidebar_image'];
  selectedStore = '';
  selectedStoreValue = '';
  selected = false;
  isOAuth: any;
  ngOnInit(): void {
    this.locations = this.getStoreLocations();
  }

  locationChange(event, loc) {
    this.selectedStore = loc.text;
    this.selectedStoreValue = loc.id;
    for (let key in this.allLocations) {
      if (this.allLocations[key]) {
        this.allLocations[key] = false;
      }
    }
    this.allLocations[loc.id] = true;
    this.selected = true;

    this.setLocation();
  }

  getStoreLocations() {
    const userDataStorage = getUserData();
    let storageData = userDataStorage;
    let stores = storageData['store_detail_dictionary']['store_details_array'];
    this.locationCount = stores.length;
    stores.forEach((location, index) => {
      if (index == 0) {
        this.allLocations[location.id] = true;
        this.selectedStore = location.text;
      } else {
        this.allLocations[location.id] = false;
      }
    });
    this.allLocations[this.selectedObjectAll.id] = true;
    this.selectValue = 'All';
    this.setLocation();
    return stores;
  }

  setLocation() {
    localStorage.setItem('selectedLocation', JSON.stringify(this.allLocations));
  }

  login() {
    this.router.navigateByUrl('/footfalls');
  }

  handleBtnEvent(event) {}
}
